import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class BuyModules extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            userModules: [],
            systemModules: [],
            orderItems: [],
            affiliateUserCode: ''
        }
    }
    componentDidMount() {
        var p1 = this.httpPost("api/v1/common/getsystemmodules", {})
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 0) {
                this.showErorrMessage(data.message);
            }
            else {
                this.state.systemModules = data.records;
            }
        });
        var p2 = this.httpPost("/api/v1/common/getusermodules", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 0) {
                    this.showErorrMessage(data.message);
                }
                else {
                    this.state.data = {
                        global: data.global
                    }
                    this.state.userModules = data.records;
                }
            });
        Promise.all([p1, p2]).then(r => {
            this.setState({
                loading: false
            })
        })
    }
    save() {
        this.httpPost("api/v1/onlinerecord/create", {
            type: 1,
            orderItems: this.state.orderItems,
            affiliateUserCode: this.state.affiliateUserCode
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                var form = document.createElement('form');
                form.setAttribute('method', 'POST');
                form.setAttribute('action', 'https://bpm.shaparak.ir/pgwchannel/startpay.mellat');
                var hiddenField = document.createElement('input');
                hiddenField.setAttribute('name', 'RefId');
                hiddenField.setAttribute('value', data.refId);
                form.appendChild(hiddenField);
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
            else
                this.showErorrMessage(data.message);
        })
        .catch(err => {
            this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
        });
    }
    selectModule(systemModuleId, count,isRenew=false) {
        var total = 0;
        var discount = 0;
        var discountDescription = '';
        this.state.systemModules.forEach(m => {
            if (m.id == systemModuleId) {
                var price = m.basePrice;
                price += (m.exPrice * count);
                if (isRenew) price = this.FixedPointNumber((price * m.renewalPercent) / 100, 0);
                total += price;
            }
        });
        total = total - discount;
        this.state.orderItems.push({
            systemModuleId,
            count,
            discount,
            discountDescription,
            total
        });
        this.setState({ orderItems: this.state.orderItems });
    }
    removeModule(systemModuleId) {
        var temp = [];

        this.state.orderItems.forEach(f => {
            if (f.systemModuleId != systemModuleId) temp.push(f);
        });
        this.state.orderItems = temp;

        this.setState({ orderItems: this.state.orderItems });
    }
    getModuleSelected(systemModuleId) {
        var v = null;
        this.state.userModules.forEach(e => {
            if (e.systemModuleId == systemModuleId) v = e;
        });
        return v;
    }
    getModuleInOrder(systemModuleId) {
        var v = null;
        this.state.orderItems.forEach(e => {
            if (e.systemModuleId == systemModuleId) v = e;
        });
        return v;
    }
    moduleIsSelected(systemModuleId) {
        if (!this.isNull(this.getModuleSelected(systemModuleId))) return true;
        if (!this.isNull(this.getModuleInOrder(systemModuleId))) return true;
        return false;
    }
    getTotal() {
        var t = 0
        this.state.orderItems.forEach(e => {
            t += e.total;
        });
        return t;
    }
    getTax() {
        return 0;
        return (this.getTotal()*10/100);
    }
    getFinal() {
        return (this.getTotal() + this.getTax());
    }
    getSystemModuleName(id) {
        var s = '';
        this.state.systemModules.forEach(item => {
            if (item.id === id) s = item.title;
        });
        return s;
    }

    renderModule(module) {
        var order = this.getModuleInOrder(module.id);
        var select = this.getModuleSelected(module.id);
        var isSelected = this.moduleIsSelected(module.id);

        return <div className="col-md-4 col-xxl-3">

            <div className="card card-bordered pricing">
                <div className="pricing-head">
                    <div className="pricing-title">
                        <h4 className="card-title title">{module.title}</h4>
                    </div>
                </div>
                <div className="pricing-body">
                    <ul className="pricing-features">
                        <li>
                            <span className="w-50">تاریخ خرید: </span>
                            {!this.isNull(select) ? <span className="ms-auto">{select.registerDateString}</span> : <span className="ms-auto">خریداری نشده</span>}
                        </li>
                        <li>
                            <span className="w-50">تاریخ انقضا: </span>
                            {!this.isNull(select) ? <span className="ms-auto">{select.expireDateString}</span> : <span className="ms-auto">خریداری نشده</span>}
                        </li>
                    </ul>
                    <div className="pricing-action">
                        {!isSelected ? <li><button onClick={e => this.selectModule(module.id, 0)} className="btn btn-success">خرید</button></li> :
                            this.isNull(order) && (select.canReBuy === true) ? <li><button onClick={e => this.selectModule(module.id, this.getModuleSelected(module.id).count, true)} className="btn btn-warning">تمدید</button></li> : null}
                    </div>
                </div>
            </div>
        </div>
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="nk-block">
                            <div className="row g-gs">
                                <div className="col-md-9 col-xxl-9">
                                    <div className="row g-gs">
                                        <div className="col-md-12 col-xxl-12">
                                            <div className="card card-bordered pricing">
                                                <div className="pricing-head">
                                                    <div className="pricing-title">
                                                        <h4 className="card-title title">فهرست ماژول های موجود جهت خرید یا تمدید و ارتقا</h4>
                                                        <p className="sub-text">لطفا ماژول های مورد نظر خود را از لیست زیر انتخاب نمایید</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.systemModules.map(module =>
                                            this.renderModule(module)
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-3 col-xxl-3">
                                    <div className="card card-bordered pricing">
                                        <div className="pricing-head">
                                            <div className="pricing-title">
                                                <h4 className="card-title title">خلاصه سفارش</h4>
                                            </div>
                                        </div>
                                        <div className="pricing-body">
                                            <ul className="pricing-features">
                                                {this.state.orderItems.map(item =>
                                                    !this.isNull(this.getModuleInOrder(item.systemModuleId)) && <li>
                                                        <span className="w-50"><a className="hand" style={{ "color": "#F4424246" }} onClick={e => this.removeModule(item.systemModuleId)}> <i className="fa fa-trash"></i></a> {this.getSystemModuleName(item.systemModuleId)}</span>
                                                        <span className="ms-auto">{this.money(this.getModuleInOrder(item.systemModuleId).total)} ریال</span>
                                                    </li>
                                                )}
                                            </ul>
                                            <hr />
                                            <ul className="pricing-features">
                                                <li><span className="w-50">جمع کل</span> <span className="ms-auto">{this.money(this.getTotal())} ریال</span></li>
                                                <li style={{ "display": "none" }}><span className="w-50">مالیات بر ارزش افزوده</span> <span className="ms-auto">{this.money(this.getTax())}  ریال</span></li>
                                                <li><span className="w-50">مبلغ نهایی قابل پرداخت</span> <span className="ms-auto">{this.money(this.getFinal())}  ریال</span></li>
                                            </ul>
                                            <ul className="pricing-features">
                                                <input placeholder="کد معرف" type="text" onChange={e => this.state.affiliateUserCode = e.target.value} className="form-control text-center" />
                                            </ul>
                                            <div className="pricing-action">
                                                <button className="btn btn-primary" onClick={e => this.save() }>تایید و پرداخت</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies)
							? this.renderNoCompanyRegister()
							: this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}